import { GoogleTagManagerEventEnum } from "../enums/GoogleTagManagerEvent.enum";

export class GoogleTagManagerModel {
    event: GoogleTagManagerEventEnum;
    env_type: string;
    app_name: string;
    element_type: string;
    element_content: string;
    section_app: string;
    screen_name: string;
    screen_type: string;
    hash_cpf: string;
    hash_cnpj: string;
    num_ec: string;

    constructor() {
        this.env_type = 'alelo:b2b';
        this.app_name = 'gestao-vt-web';
        this.num_ec = '';
    }
}
